import React from 'react';
import Toggle from 'react-toggle';
import { ChangeEvent } from 'react';

interface Iprops {
    onHideVirtualChange: (event: ChangeEvent<HTMLInputElement>) => void;
    checked: boolean;
}

const HideVirtualMobileToggle = ({ onHideVirtualChange, checked }: Iprops) => {
    return (
        <div className="hide-virtual-toggle">
            <label className="hide-virtual-toggle-label-container">
                <Toggle icons={false} className="beacon-toggle" checked={checked} onChange={onHideVirtualChange} />
                <span className="hide-virtual-toggle-label">Hide Virtual/Decommissioned</span>
            </label>
        </div>
    );
};

export default HideVirtualMobileToggle;
